import React from "react";

import AmountPrice from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/AmountPrice";
import CustomProductVariantContainer from "../CustomProductVariant";
import CustomAmountPrice from "../CustomAmountPriceContainer";

const CustomAmountPriceContainer = (props) => {

  return (
    <AmountPrice
      {...props}
      ProductVariantComponent={CustomProductVariantContainer}
      AmountPriceContainer={CustomAmountPrice}
    >
    </AmountPrice>
  );
};

export default CustomAmountPriceContainer;
